import { render } from "./HappinessDisplay.vue?vue&type=template&id=3ea55a5a"
import script from "./HappinessDisplay.vue?vue&type=script&lang=js"
export * from "./HappinessDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__